import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';

export const GridElement = styled.div`
  width: 100%;
  grid-column: span 2;
  height: ${SIZES['40']};
`;
